import { Controller } from "@hotwired/stimulus"
import { MaskInput } from "maska"

export default class extends Controller {
  connect() {
    this.mask = new MaskInput(this.element, { mask: "8 (###) ###-##-##" })
  }
  disconnect() {
    this.mask?.destroy()
  }
}
